<template>
	<div class="trial_apply _popRight" id="trialapply_pop" style="display: block;"><!-- trial_apply -->
		<div class="pop_right" style="right: 0px;"><!-- pop_right -->
			<ul class="pop_right_header2">
				<li><h2>试用申请</h2></li>
				<li><btn class="pop_right_close2" name="pop-close" @click="closeFloat"></btn></li>
			</ul>
			<div class="pop_right_main"><!-- main -->
				
				<div class="form-tips"><h4>填写下方信息，我们会尽快与您联系</h4></div>
				
				<ul class="form_list">
					<li>
						<h4>申请主体</h4>
						<div class=""><input type="text" class="s_input" placeholder="个人/组织/企业名称" v-model="shiyongform.name" ></div>
						<!-- <div class="s_tip" >xxxxxxxxx</div> -->
					</li>
					<li>
						<h4>邮箱</h4>
						<div class=""><input type="text" class="s_input" placeholder="example@example.com" v-model="shiyongform.email" ></div>
						<!-- <div class="s_tip" >xxxxxxxxx</div> -->
					</li>
					<li>
						<h4>联系电话</h4>
						<div class=""><input type="text" class="s_input" placeholder="固话请输入区号-电话号" v-model="shiyongform.phone" ></div>
						<!-- <div class="s_tip" >xxxxxxxxx</div> -->
					</li>
				</ul>
				
			</div><!-- /main -->
			<div class="pop_right_footer2">
					<btn class="s_btn" @click="addshiyong"  >提交</btn>
			</div>
		</div><!-- /pop_right -->
		<div class="pop_bg" style="display: block;" @click="closeFloat"></div>
	</div><!-- /trial_apply -->
</template>

<script>
	export default {
		data() {
			return {
				shiyongform: {
					name: '',
					email:'',
					phone:''
				},
			}
		},
		props:[
			'userinfo'
		],
		methods: {
			addshiyong:function(){
				if(!this.shiyongform.name){
					this.$message({
						message: '请填写个人/组织/企业名称',
						type: 'warning'
					});
					
					return false;
				}
				else if (!this.shiyongform.email){
					this.$message({
						message: '请填写邮箱',
						type: 'warning'
					});
					
					return false;
				}
				else if (!this.shiyongform.phone){
					this.$message({
						message: '请填写电话',
						type: 'warning'
					});
					
					return false;
				}
				
				if(this.shiyongform.email){
					var regemail=/^[a-zA-Z0-9_-]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/;
					if(!regemail.test(this.shiyongform.email)){
						this.$message({
							message: '请正确填写邮箱',
							type: 'warning'
						});
						return false;
					}
				}
				
				if(this.shiyongform.phone){
					var regmobile=/^(0|86|17951)?(13[0-9]|15[012356789]|17[01678]|18[0-9]|14[57])[0-9]{8}$/;
					var regtel=/^(0[0-9]{2,3}\-)([2-9][0-9]{6,7})+(\-[0-9]{1,4})?$/;
					if((!regmobile.test(this.shiyongform.phone))&&(!regtel.test(this.shiyongform.phone))){
						this.$message({
							message: '请填写正确的联系电话,固定电话请添加区号',
							type: 'warning'
						});
						return false;
					}
				}
				
				var tempshiyong={
					name:this.shiyongform.name,
					email:this.shiyongform.email,
					phone:this.shiyongform.phone
				}
				let _this = this;
				this.$http({
						method: 'post',
						url: 'AddUserApply',
						responseType: 'json',
						params: {
							feedbacktype:3,
							title:'试用申请',
							content: JSON.stringify(tempshiyong)
						},
					})
					.then(function(response) {
						if(response.data.code==20000){
							_this.$message({
								message: '试用申请提交成功',
								type: 'success'
							});
							_this.shiyongform.name='';
							_this.shiyongform.email='';
							_this.shiyongform.phone='';
							_this.closeFloat();
							_this.$track([
								['pagetype','添加试用申请']
							]);
						}
						else{
							_this.$message({
								message: '试用申请提交失败',
								type: 'error'
							});
						}
					})
					.catch(function(error) {
						_this.$message({
							message: '试用申请提交失败',
							type: 'error'
						});
						// _this.closeFloat();
						console.log(error);
					});
			},
			closeFloat: function() {
				this.$emit('closefloat');
			},
			
		},
	}
</script>

<style>
</style>
